<template>
  <!--svg v-bind:id="chartId" width="560" height="500" viewBox="0 0 560 500"/-->
  <g v-bind:id="chartId" class="barchart"/>
</template>

<script>
import * as d3 from 'd3';

export default {
  name: 'Barchart',
  props: {
    id: String,
    data: {},
    width: Number,
    height: Number,
    rotateXLabels: Boolean,  // if true rotate x axis labels
    darkMode: Boolean  // if true all lines and labels are dark, otherwise light
  },
    data() {
        return {
          chartId: 'chart-' + this.$props.id,
          diagram: null,
          loadData: {},
          width_: this.$props.width != undefined ? this.$props.width : 200,
          height_: this.$props.height != undefined ? this.$props.height : 200,
          fadeInTime: 1000,
          fadeOutTime: 300,
          label: {"avgSi": "Sinnempfinden", "avgSv": "Selbstverwirklichung", "avgGe": "Gemeinschaft", "avgHa": "Glück"},
          chartData: (this.$props.data != undefined && this.$props.data != null) ? this.$props.data : {
            "criteria":    {
              "name": "sallery",
              "values":       [ "-30T€", "31-50T€", "51-70T€", "70-100T€", "100T€+" ]
            },
            "data":    [
                    { "total": 125, "avgSi": 62, "avgSv": 56, "avgGe": 64, "avgHa": 61 },
                    { "total": 103, "avgSi": 62, "avgSv": 59, "avgGe": 64,"avgHa": 61 },
                    { "total": 69, "avgSi": 65, "avgSv": 63, "avgGe": 61, "avgHa": 63 },
                    { "total": 12, "avgSi": 58, "avgSv": 60, "avgGe": 50, "avgHa": 56 },
                    { "total": 12, "avgSi": 70, "avgSv": 73, "avgGe": 63, "avgHa": 68}
            ]
          },
          chartData1: {
            "criteria":    {
              "name": "sallery",
              "values":       [ "-30T€", "31-50T€", "51-70T€", "70-100T€"]
            },
            "data":    [
                    { "total": 125, "avgSi": 60, "avgSv": 60, "avgGe": 60, "avgHa": 60 },
                    { "total": 103, "avgSi": 62, "avgSv": 59, "avgGe": 64,"avgHa": 61 },
                    { "total": 69, "avgSi": 65, "avgSv": 63, "avgGe": 61, "avgHa": 63 },
                    { "total": 12, "avgSi": 70, "avgSv": 73, "avgGe": 63, "avgHa": 68}
            ]
          },
          chartData2: {
            "criteria":    {
              "name": "sallery",
              "values":       [ "-30T€", "31-50T€", "51-70T€", "70-100T€", "100T€+" ]
            },
            "data":    [
                    { "total": 125, "avgSi": 65, "avgSv": 65, "avgGe": 65, "avgHa": 65 },
                    { "total": 103, "avgSi": 62, "avgSv": 59, "avgGe": 64,"avgHa": 61 },
                    { "total": 69, "avgSi": 65, "avgSv": 63, "avgGe": 61, "avgHa": 63 },
                    { "total": 12, "avgSi": 58, "avgSv": 60, "avgGe": 50, "avgHa": 56 },
                    { "total": 12, "avgSi": 70, "avgSv": 73, "avgGe": 63, "avgHa": 68}
            ]
          },
          chartData3: {
            "criteria":    {
              "name": "sallery",
              "values":       [ "-30T€", "31-50T€", "51-70T€", "70-100T€", "100T€+" ]
            },
            "data":    [
                    { "total": 125, "avgSi": 25, "avgSv": 70, "avgGe": 70, "avgHa": 70 },
                    { "total": 103, "avgSi": 62, "avgSv": 59, "avgGe": 64,"avgHa": 61 },
                    { "total": 69, "avgSi": 65, "avgSv": 63, "avgGe": 61, "avgHa": 63 },
                    { "total": 12, "avgSi": 58, "avgSv": 60, "avgGe": 50, "avgHa": 56 },
                    { "total": 12, "avgSi": 70, "avgSv": 73, "avgGe": 63, "avgHa": 68}
            ]
          }
        }
    },
    mounted: function () {
      // `this` points to the vm instance
      // this.fetchDate();
      // create diagram
      this.diagram = this.setupDiagram(this.chartId);
      // draw data
      this.diagram.update(this.$props.data);
/*    this.diagram.update(this.chartData1);
      var vm = this;
      // update data
      setTimeout(function(){ vm.diagram.update(vm.chartData2);}, 5000);
      // update data
      setTimeout(function(){vm.diagram.update(vm.chartData3);}, 8000);
      // update data
      setTimeout(function(){vm.diagram.update(vm.chartData1);}, 12000); */
    },
    watch: {
        data(newData) { // eslint-disable-line no-unused-vars
          //console.log('Data changed to ' + newData.criteria.name) // eslint-disable-line no-console
          // update gauge
          this.diagram.update(this.$props.data);
        }
    },
    methods: {

/*         // fetch data
        async fetchDate() {
          let data = await d3.csv("a/data.csv", function(d, i, columns) {
            for (var j = 1, n = columns.length; i < n; ++j) d[columns[j]] = +d[columns[j]];
            return d;
          });
          //debugger;
          this.loadData = data;
        }, */

        // setup chart
        setupDiagram(elementId) {

          var svg = d3.select("#" + elementId),
              margin = {top: 10, right: 20, bottom: 30, left: 40},
              width = this.width_,
              height = this.height_
            //width = +svg.attr("width") - margin.left - margin.right,
            //height = +svg.attr("height") - margin.top - margin.bottom

          var g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")")
            .attr("class", this.$props.darkMode ? "dark" : "light");

          // outer x scale
          var x0 = d3.scaleBand()
              .rangeRound([0, width])
              .paddingInner(0.15);
          // inner x scale
          var x1 = d3.scaleBand()
              .padding(0.1);
          // y scale (top to bottom)
          var y = d3.scaleLinear()
              .rangeRound([height, 0]);
          // color scale 
          var z = d3.scaleOrdinal()
              .range(["#7CC9DB", "#E9561F", "#F5A019", "#00986D"]);

          // gridlines in x axis function
          function make_x_gridlines() {		
              return d3.axisBottom(x0)
                  .ticks(5)
          }

          // gridlines in y axis function
          function make_y_gridlines() {		
              return d3.axisLeft(y)
                  .ticks(10)
          }

          // x (vertical) gridlines
          g.append("g")			
              .attr("class", "x grid")
              .attr("transform", "translate(0," + height + ")")

          // y (horizontal) gridlines
          g.append("g")			
              .attr("class", "y grid")

          // x axis
          g.append("g")
              .attr("class", "x axis " + (this.$props.rotateXLabels ? "rotate-labels" : ""))
              .attr("transform", "translate(0," + height + ")")

          // y axis + legend
          g.append("g")
              .attr("class", "y axis")
            .append("text")
              .attr("transform", "rotate(-90) translate(-5)") // rotate the text!
              //.attr("class","label")
              .attr("y", 6)
              .attr("dy", ".8em")
              .attr("fill", function() {return this.textColor})
              .style("text-anchor", "end")
              .text("Prozent");

          // legend
          g.append("g")
            .attr("class", "legend")
            .attr("text-anchor", "end")
            // temp only
/*            .append("text")
                .attr("class","title")
                .attr("y", 0)
                .attr("dy", "1em")
                .text("unknown")
                .style("transform", "translate(250px, 0px)") */
                ;
      
          var vm = this;

          // draw diagram content and updates if data changed
          function draw(data) {
            //console.log('data ' + JSON.stringify(data)) // eslint-disable-line no-console

            //var keys = Object.keys(data.data[0]).slice(1,5) // => [avgSi, avgSv, avgGe, avgHa]
            var keys = Object.keys(data.data[0])        // => [avgSi, avgSv, avgGe, avgHa]
            //console.log('keys ' + JSON.stringify(keys)) // eslint-disable-line no-console

            // map criteria values [] to outer x range
            x0.domain(data.criteria.values.map(function(d){ return d;}))
            // map data catergories [avgSi, avgSv, avgGe, avgHa] to inner x range
            x1.domain(keys).rangeRound([0, x0.bandwidth()]);
            // create domain for y axis based on max values of [avgSi, avgSv, avgGe, avgHa] data
            var minVal= d3.min(data.data, function(d) { return d3.min(keys, function(key) { return d[key]; }); })
            var maxVal = d3.max(data.data, function(d) { return d3.max(keys, function(key) { return d[key]; }); })         
            if (minVal === 0 && maxVal === 0) {maxVal = 100} // make y axis to go from 0 -100 if values are 0
            
            //console.log('Y Range: ' + d3.max([minVal-5, 0]) + ' - ' + d3.min([maxVal+15, 100])) // eslint-disable-line no-console
            y.domain([d3.max([minVal-5, 0]), d3.min([maxVal+15, 100])]).nice();

            // populate x gridlines
            g.select('.x.grid').transition().duration(vm.fadeInTime).call(make_x_gridlines()
              .tickSize(-height)
              .tickFormat(""));

            // populate y gridlines
            g.select('.y.grid').transition().duration(vm.fadeInTime).call(make_y_gridlines()
              .tickSize(-width)
              .tickFormat(""));

            // populate x axis
            g.select('.x.axis').transition().duration(vm.fadeInTime).call(d3.axisBottom(x0));

            // populate y axis
            g.select('.y.axis').transition().duration(vm.fadeInTime).call(d3.axisLeft(y).ticks(null, "s"));
           
            //update title (temp only)
            g.select(".title").text(data.criteria.name);

            // bind data to bargroups (and bars)
            var bargroups = g.selectAll(".bargroup").data(data.data);

            // remove bargroups
            bargroups.exit().transition().duration(vm.fadeOutTime)
              .style('fill-opacity', 1e-6)
              .remove()
              ;

            // enter bargroups
            bargroups.enter().append("g")
              .attr("class", "bargroup")
              .attr("transform", function(d,i) { return "translate(" + x0(data.criteria.values[i]) + ",0)"; })
/*               .selectAll(".bar") 
                .data(function(d) { return keys.map(function(key) { return {key: key, value: d[key]}; }); })
                .enter().append("rect") 
                  .transition().duration(vm.fadeInTime)        
                  .call(drawBar) */
              ;

            // update bargroups
            bargroups
              .transition().duration(vm.fadeInTime)
              .attr("transform", function(d,i) { return "translate(" + x0(data.criteria.values[i]) + ",0)"; })
              ;

            // bind bar data (taken from parent (bargroup) data)
            var bars = g.selectAll(".bargroup").selectAll(".bar").data(function(d) { return keys.map(function(key) { return {key: key, value: d[key]}; }); });

            // remove bars
            bars.exit().transition().duration(vm.fadeOutTime)
              .style('fill-opacity', 1e-6)
              .remove()
            ;

            // enter bars
            bars.enter()
              .append("rect")
                .transition().duration(vm.fadeInTime)
                .call(drawBar)       
            ;

            // update bars
            bars
              .transition().duration(vm.fadeInTime)
              .call(drawBar)
            ;

            // draw bar
            function drawBar(selection) {
              selection.attr("class", "bar")
                .attr("x", function(d) { return x1(d.key); })
                .attr("y", function(d) { return y(d.value); })
                .attr("rx", "6px")
                .attr("ry", "6px")
                .attr("width", x1.bandwidth()-4)
                .attr("height", function(d) { return height - y(d.value); })
                .attr("fill", function(d) { return z(d.key); })
                ;
            }

            // bind data to legend
            var legendItem = g.selectAll(".legend").selectAll("g")
              .data(keys.slice().reverse());

            // remove legend item
            legendItem.exit().transition().duration(vm.fadeOutTime)
              .style('fill-opacity', 1e-6)
              .remove()
            ;
            // enter legend item
            var lg = legendItem.enter()
              .append("g")
                .attr("transform", function(d, i) { return "translate(0," + i * 24 + ")"; })
                ;
            lg.append("rect").call(drawLegendRect);
            lg.append("text").call(drawLegendText);

            // update legend item
            lg.transition().duration(vm.fadeInTime).selectAll("g").select("rect").call(drawLegendRect);
            lg.transition().duration(vm.fadeInTime).selectAll("g").select("text").call(drawLegendText);

            // draw legend item
            function drawLegendRect(selection) {
               selection.attr("x", width - 19)
                .attr("rx", "3px")
                .attr("ry", "3px")
                .attr("width", 19)
                .attr("height", 19)
                .attr("fill", z);
            }
            function drawLegendText(selection) {
               selection.attr("x", width - 24)
                .attr("y", 9.5)
                .attr("dy", "0.32em")
                .text(function(d) { return vm.label[d]; });
            }
          }

          // update
          function Diagram() {
            // update chart
            this.update = function(data) {
                /* eslint-disable no-debugger */
                //debugger;
                draw(data);    
            };
          }
          return new Diagram();
        } // end setupChart

    }
  }

</script>

<style lang="scss">
.barchart {
  .light, .light text {
    stroke: #ffffff;
    fill: #ffffff;
    color: #ffffff;
  }
  .dark, .dark text {
    stroke: #111111;
    fill: #111111;
    color: #111111;
  }
  .x.rotate-labels text {
    transform: rotate(40deg) translate(10px,0px) ;
    text-anchor: start;
  }
  .axis line {
    /* stroke: #ffffff; */
  }

  .axis path{
    /* stroke: #ffffff; */
  }

  .axis text,
  .legend text {
    /* fill: #ffffff; */
    stroke-width: 0;
    font-family: 'Nunito';
    font-size: 1rem;
    font-weight: lighter;
  } 

  .grid line {
    /* stroke: #ffffff; */
    stroke-opacity: 0.1;
    shape-rendering: crispEdges;
  }

  .grid .domain {
    stroke-width: 0px;
  }

  .bar,
  .legend rect {
    stroke-width: 1;
    stroke: #ffffff;
  }
}

</style>

